import {AbstractService} from 'services/AbstractService';

const USER_ACCOUNTS = '/api/useraccounts';

export class ManagersService extends AbstractService {
  getManagersList () {
    return this.client.get(USER_ACCOUNTS);
  }
}
